import { currentWorkspaceSchema } from '@mio/shared';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiRequest } from '../client';

export const workspaceQuery = queryOptions({
  queryKey: ['workspace', 'current'],
  queryFn: ({ signal }) => apiRequest('/workspaces/me', currentWorkspaceSchema, { signal }),
  refetchOnWindowFocus: true,
  refetchInterval: (query) => (query.state.data?.busyOperation ? 1500 : 15_000),
});

export function useCurrentWorkspace() {
  return useQuery(workspaceQuery);
}
